var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3823 9.86224C18.3957 10.1821 18.2246 10.4813 17.9422 10.6321L3.14428 18.5331C2.84287 18.694 2.47376 18.6546 2.21307 18.4337C1.95239 18.2129 1.85295 17.8552 1.96221 17.5315L4.35292 10.4475L1.38049 3.58729C1.24465 3.27377 1.31395 2.9091 1.55534 2.66727C1.79672 2.42544 2.16127 2.35546 2.47504 2.49073L17.8796 9.13173C18.1736 9.25846 18.369 9.54239 18.3823 9.86224ZM5.85156 11.2191L4.21349 16.0728L13.9359 10.8818L5.85156 11.2191ZM13.8665 9.21658L3.74545 4.85336L5.78209 9.55384L13.8665 9.21658Z",
    fill: "#00000090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendessage);
export default __webpack_public_path__ + "static/media/Sendessage.8aeb2e4339d14beaa26d4982e444c0ae.svg";
export { ForwardRef as ReactComponent };